/*
 src/actions/simpleAction.js
*/
import _ from "lodash";
import store from "../../store";
import {
  INITIAL,
  SET_DOCJSON,
  SET_DEPENDENCY_JSON,
  SET_DYNAMIC_OPTION_DONE,
  UPDATE_DYNAMIC_OPTION_DONE,
  SET_ORG_ID_CONST,
  SET_CHANGES_LOG,
  SET_STORE_VALS,
  SET_ATHENA_STORAGE,
  UPDATE_ATHENA_STORAGE,
  SET_ONE_SIDE_PDF_KEY,
  SET_ACTIVE_TAB,
  SET_FOCUSED_SERVICE_ID,
  RERENDER,
  SET_DIALOG_DATA,
  SET_VALIDATION_ERROR,
  UPDATE_VALIDATION_ERROR,
  CLEAR_VALIDATION_ERROR,
  ADD_CHILDREN,
  CHANGE_FORM_VALUES,
} from "./dynamicFormsActionTypes";

export function isNullOrEmpty(value, operator) {
  if (operator === "EQ")
    return value === "" || value === undefined || value === null;
  if (operator === "NE")
    return value !== "" && value !== undefined && value !== null;
}

export function compileOperators(dependency, formValues) {
  dependency.forEach((dep) => {
    dep.satisfied = false;

    if (dep.operator === "EQ") {
      dep.satisfied =
        dep.value === ""
          ? isNullOrEmpty(formValues[dep.lookFor], dep.operator)
          : formValues[dep.lookFor] === dep.value;
    } else if (dep.operator === "NE") {
      dep.satisfied =
        dep.value === ""
          ? isNullOrEmpty(formValues[dep.lookFor], dep.operator)
          : formValues[dep.lookFor] !== dep.value;
    }
  });
  return dependency.every((item) => item.satisfied === true);
}

export function checkDependency(dependency) {
  const state = store.getState();
  const formValues = state.dynamicForms.formValues;
  return compileOperators(dependency, formValues);
}

export const setInitialState = () => ({ type: INITIAL });
export const setDOCJSON = (payload) => ({ type: SET_DOCJSON, payload });
export const setDependencyJSON = (payload) => ({ type: SET_DEPENDENCY_JSON, payload });
export const setDynamicOptionDone = (payload) => ({ type: SET_DYNAMIC_OPTION_DONE, payload });
export const updateDynamicOptionDone = (payload) => ({ type: UPDATE_DYNAMIC_OPTION_DONE, payload });
export const setOrgIdConst = (payload) => ({ type: SET_ORG_ID_CONST, payload });
export const setChangesLog = (payload) => ({ type: SET_CHANGES_LOG, payload });
export const setStoreVals = (payload) => ({ type: SET_STORE_VALS, payload });
export const setAthenaStorage = (payload) => ({ type: SET_ATHENA_STORAGE, payload });
export const updateAthenaStorage = (payload) => ({ type: UPDATE_ATHENA_STORAGE, payload });
export const setOneSidePDFKey = (payload) => ({ type: SET_ONE_SIDE_PDF_KEY, payload });
export const setActiveTab = (id, index) => ({ type: SET_ACTIVE_TAB, payload: { id, index } });
export const setFocusedServiceID = (payload) => ({ type: SET_FOCUSED_SERVICE_ID, payload });
export const rerender = (payload) => ({ type: RERENDER, payload });
export const setDialogData = (payload) => ({ type: SET_DIALOG_DATA, payload });
export const setValidationError = (payload) => ({ type: SET_VALIDATION_ERROR, payload });
export const updateValidationError = (payload) => ({ type: UPDATE_VALIDATION_ERROR, payload });
export const updateValidationErrorByKey = (key, value) => ({
  type: UPDATE_VALIDATION_ERROR,
  payload: {
    key,
    value,
  },
});
export const clearValidationError = (payload) => ({ type: CLEAR_VALIDATION_ERROR, payload });
export const initialState = setInitialState;
export const handleTreeChange = setDOCJSON;
export const update_dependencyJson = setDependencyJSON;

export function addChildren(parent_id) {
  return (dispatch) => {
    const state = store.getState();
    const UJ_JSON = state.dynamicForms.UJ_JSON;

    if (!UJ_JSON) return;

    let children = _.map(UJ_JSON, (item) => {
      const isRoot = parent_id === null && (!item.parentId || item.parentId === "null");
      const isChild = item.parentId == parent_id;

      if (
        (isRoot || isChild) &&
        item.type !== "dropdown-option" &&
        item.type !== "Screen_Found"
      ) {
        let active = true;
        if (item.dependency && item.dependency.length) {
          active = checkDependency(item.dependency);
        }
        return { ...item, active };
      }
      return item;
    });

    dispatch({
      type: ADD_CHILDREN,
      UJ: children,
    });
  };
}

export function changeFormValues(formValues) {
  return (dispatch) => {
    dispatch({ type: CHANGE_FORM_VALUES, formValues });
  };
}

export function add_UJ_JSON(json) {
  return (dispatch) => {
    dispatch({
      type: ADD_CHILDREN,
      UJ: json,
    });
  };
}

export function getDropdownOptions(parent_id) {
  const state = store.getState();
  const UJ_JSON = state.dynamicForms.UJ_JSON;
  let options = _.filter(UJ_JSON, (item) => {
    if (item.type === "dropdown-option" && item.parentId === parent_id) {
      if (item.dependency && item.dependency.length) {
        return checkDependency(item.dependency);
      } else {
        return true;
      }
    } else {
      return false;
    }
  });
  const children = _.map(UJ_JSON, (item) => {
    if (item.id === parent_id && item.type === "select") {
      item.options = options;
    }
    return item;
  });
  return (dispatch) => {
    dispatch({
      type: ADD_CHILDREN,
      UJ: children,
    });
  };
}

export function changeDependencyValues(parent_id) {
  const state = store.getState();
  const UJ_JSON = state.dynamicForms.UJ_JSON;
  let children = _.filter(
    UJ_JSON,
    (item) => item.type === "select" && item.parentId === parent_id
  );
  return (dispatch) => {
    children.forEach((child) => {
      dispatch(getDropdownOptions(child.id));
    });
  };
}
